import { gql } from '@apollo/client'
import PubSub from 'pubsub-js'
import { makeInteger } from '../../utils'
import allHooks from '../../hooks/allHooks'
import { CHOICE_TYPE, FIELD_TYPE } from '../../constants'
import { CHOICES_QUERY } from '../../graphql'

const CHOICES = gql(CHOICES_QUERY)

export async function getFieldChoices(field, object, parentObjectId, formInputs) {
  console.log('AppObjectFieldUtils.getFieldChoices: ', field, object, parentObjectId, formInputs)
  if (FIELD_TYPE.isForeignKey.includes(makeInteger(field.type.id))) {
    field.choiceType = { id: CHOICE_TYPE.foreignKey }
  }
  let choices = []
  const objectId = object ? object.id : null
  switch (makeInteger(field.choiceType.id)) {
    // CONSTANT
    case CHOICE_TYPE.constant:
      // format:  "1","Florida","Y","3","Georgia","Y"
      const valueStrings = JSON.parse(`[${field.choiceValue}]`)
      console.log('valueStrings: ', valueStrings)
      let startIndex = 0
      // ignore value strings starting with "" value
      if (!valueStrings[0]) {
        startIndex = 3
      }
      for (let i = startIndex; i < valueStrings.length - 2; i += 3) {
        if (valueStrings[i + 2] === 'Y') {
          choices.push({ id: valueStrings[i], name: valueStrings[i + 1] })
        }
      }
      break
    // USE HOOK
    case CHOICE_TYPE.useHook:
      const parts = field.choiceValue.split('.')
      const moduleName = parts[0]
      const functionName = parts[1]
      console.log('AppObjectFieldUtils.getChoiceValues: retrieving HOOK select item choices...')
      choices = await allHooks[moduleName][functionName](field, object, parentObjectId, formInputs)
      break
    // SQL or FOREIGN KEY
    case CHOICE_TYPE.foreignKey:
    case CHOICE_TYPE.sql:
      try {
        console.log('AppObjectFieldUtils.getChoiceValues: retrieving FK select item choices...')
        const results = await window.apolloClient.query({ query: CHOICES, variables: { fieldId: field.id, objectId: objectId, parentObjectId: parentObjectId } })
        console.log('CHOICES_QUERY results: ', results)
        choices = results.data.choices
      } catch (e) {
        console.log(e)
      }
      break
    default:
      console.log(`AppObjectFieldUtils.getChoiceValues: field.choiceType of ${field.choiceType} was not handled.`)
  }
  console.log('AppObjectFieldUtils.getFieldChoices: returning choices: ', choices)
  return choices
}

export async function getSelectFieldChoices(field, object, parentObjectId, formInputs) {
  console.log('AppObjectFieldUtils.getSelectFieldChoices: ', field, object, parentObjectId, formInputs)

  const choices = await getFieldChoices(field, object, parentObjectId, formInputs)
  if (choices) {
    for (let i = 0; i < choices.length; i++) {
      choices[i].value = choices[i].id
      choices[i].label = choices[i].name
    }
  }
  console.log('AppObjectFieldUtils.getSelectFieldChoices: returning choices', choices)
  return choices
}

export function calcMaxLength(options) {
  let maxLength = 0
  if (options) {
    options.forEach((option) => {
      if (option.label && option.label.length > maxLength) {
        maxLength = option.label.length
      }
    })
  }
  return maxLength
}

export function setupDependsOn(field, object, handleDependsOnChangeEvent) {
  const tokens = []
  if (field.dependsOn) {
    for (let dependsOn of field.dependsOn) {
      tokens.push(PubSub.subscribe(`OBJECT: ${object.id} ${dependsOn.name} CHANGED`, handleDependsOnChangeEvent))
      return function cleanup() {
        for (let token of tokens) {
          PubSub.unsubscribe(token)
        }
      }
    }
  }

}
